<template>
    <div class="dashboard">
        <h1>運転日報一覧</h1>
        <div class="l-5-10-m--all">
            <div>
                <input v-model="setSelectDate" type="date" @change="changeDate()">
            </div>
            <div>
                <select v-model="changeMode">
                    <option value="driver">ドライバー</option>
                    <option value="vehicle">車両</option>
                </select>
            </div>
            <div v-if="selectMode === 'driver'">
                <select v-model="selectDriver" @change="fetchingListDailyReports()">
                    <option v-for="(data, key) in listDrivers" :key="key" :value="data.driver_id">{{ data.driver_name }}</option>
                </select>
            </div>
            <div v-if="selectMode === 'vehicle'">
                <select v-model="selectVehicle" @change="fetchingListDailyReportsVehicle()">
                    <option v-for="(data, key) in listVehicles" :key="key" :value="data.vehicle_id">{{ data.vehicle_id }}</option>
                </select>
            </div>
            <div>
                &nbsp;
            </div>
            <div>
                &nbsp;
            </div>
        </div>
        <div class="l-mb4 l-5-10-m--all">
            <div>
                <select v-model="stamp.qmr">
                    <option value="mizutani">QMR：水谷</option>
                    <option value="watanabe">QMR：渡辺</option>
                </select>
            </div>
            <div>
                <select v-model="stamp.plantManager">
                    <option value="mizutani">工場長：水谷</option>
                    <option value="watanabe">工場長：渡辺</option>
                </select>
            </div>
            <div>
                <select v-model="stamp.sectionChief1">
                    <option value="mizutani">課長：水谷</option>
                    <option value="watanabe">課長：渡辺</option>
                </select>
            </div>
            <div>
                <select v-model="stamp.sectionChief2">
                    <option value="mizutani">係長：水谷</option>
                    <option value="watanabe">係長：渡辺</option>
                </select>
            </div>
            <div>
                <button class="button--oval--other" type="button" @click="download()">
                    PDFダウンロード
                </button>
            </div>
        </div>
        <table>
            <tr>
                <template v-for="data in adjustTableSet">
                    <th v-if="data.key !== 'checked_residual_water'" :key="data.key" :class="data.class">
                        {{ data.head }}
                    </th>
                </template>
                <th class="is-right">&nbsp;</th>
            </tr>
            <tr v-for="(list, index) in sortingListDailyReports" :key="`list${index}`">
                <template v-for="data in adjustTableSet">
                    <template v-if="data.key !== 'checked_residual_water'">
                        <td v-if="data.key === 'lapse_time_1'" :key="`list${index}${data.key}1`" :class="[data.class, setClassWarning(list.residual_water_time, list.site_arrival_time)]">
                            {{ calcLapseTime(list.residual_water_time, list.site_arrival_time) }}
                        </td>
                        <td v-else-if="data.key === 'lapse_time_2'" :key="`list${index}${data.key}2`" :class="[data.class, setClassWarning(list.site_arrival_time, list.site_departure_time)]">
                            {{ calcLapseTime(list.site_arrival_time, list.site_departure_time) }}
                        </td>
                        <td v-else-if="data.key === 'lapse_time_3'" :key="`list${index}${data.key}3`" :class="[data.class, setClassWarning(list.site_departure_time, list.factory_arrival_time)]">
                            {{ calcLapseTime(list.site_departure_time, list.factory_arrival_time) }}
                        </td>
                        <td v-else :key="`list${index}${data.key}`" :class="data.class">
                            {{ list[data.key] }}
                        </td>
                    </template>
                </template>
                <td class="is-right">
                    <router-link class="button--primary" :to="{ name: 'offices_daily_reports_update', params: { id: String(list.id) }, query: { source: 'daily_reports' }}" type="button" tag="button">変更</router-link>
                </td>
            </tr>
        </table>
        <Modal :modal="modal" @action="modalAction($event)" @close="$_modalClose()" />
    </div>
</template>

<script>
    "use strict";

    import common from "@/mixins/common";
    import pdf from "@/mixins/pdf";
    import sorts from "@/mixins/sort";
    import { stamp } from "@/assets/scripts/stamp.js";

    const tableDailyReports = [
        {
            "class": "is-wrap",
            "head": "施工業者",
            "key": "contractor",
        },
        {
            "class": "is-wrap",
            "head": "現場名",
            "key": "delivery_destination_name",
        },
        {
            "class": "",
            "head": "車両ID",
            "key": "vehicle_id",
        },
        {
            "class": "is-center",
            "head": "車両サイズ",
            "key": "vehicle_size_name",
        },
        {
            "class": "is-right",
            "head": "納入量（㎥）",
            "key": "delivery_allocations_amount",
        },
        {
            "class": "",
            "head": "残水",
            "key": "checked_residual_water",
        },
        {
            "class": "is-right",
            "head": "工場発時刻", // 元・残水時刻
            "key": "residual_water_time",
        },
        {
            "class": "is-right",
            "head": "時間差（分）",
            "key": "lapse_time_1",
        },
        {
            "class": "is-right",
            "head": "現場着時刻",
            "key": "site_arrival_time",
        },
        {
            "class": "is-right",
            "head": "時間差（分）",
            "key": "lapse_time_2",
        },
        {
            "class": "is-right",
            "head": "現場発時刻",
            "key": "site_departure_time",
        },
        {
            "class": "is-right",
            "head": "時間差（分）",
            "key": "lapse_time_3",
        },
        {
            "class": "is-right",
            "head": "工場着時刻",
            "key": "factory_arrival_time",
        },
    ];

    export default {
        "mixins": [
            common,
            pdf,
            sorts,
        ],
        data() {
            return {
                "listDailyReports": [],
                "listDailyReportsDetail": [],
                "listDailyReportsDetailVehicle": [],
                "listDailyReportsVehicle": [],
                "listDrivers": [],
                "params": {
                    "date": "",
                    "month": "",
                },
                "selectDriver": "",
                "selectMode": "driver",
                "selectVehicle": "",
                "stamp": {
                    "plantManager": "mizutani",
                    "qmr": "mizutani",
                    "sectionChief1": "mizutani",
                    "sectionChief2": "mizutani",
                },
                "sync": {
                    "drivers": "",
                    "vehicles": "",
                },
                "tableSet": [],
            };
        },
        "computed": {
            adjustTableSet() {
                return this.setTable();
            },
            "changeMode": {
                // モードを変更
                get() {
                    return this.selectMode;
                },
                set(value) {
                    if (value === "driver") {
                        this.selectDriver = this.listDrivers[0].driver_id;
                        this.fetchingListDailyReports();
                    } else if (value === "vehicle") {
                        this.selectVehicle = this.listVehicles[0].vehicle_id;
                        this.fetchingListDailyReportsVehicle();
                    }
                    this.selectMode = value;
                },
            },
            sortingListDailyReports() {
                let list = [];
                const listWaterTime = [];
                const listNotWaterTime = [];
                let sortListWaterTime =[];
                let sortListNotWaterTime =[];
                let selectList = [];
                if (this.selectMode === "driver") {
                    selectList = this.listDailyReports;
                } else if (this.selectMode === "vehicle") {
                    selectList = this.listDailyReportsVehicle;
                }
                // 工場発時刻（元・残水時刻）の存在を仕分け
                for (let data of selectList) {
                    if (data.residual_water_time) {
                        listWaterTime.push(data);
                    } else {
                        listNotWaterTime.push(data);
                    }
                }
                // 工場発時刻（元・残水時刻）で昇順
                sortListWaterTime = this.$_sorting(listWaterTime, "residual_water_time");
                // 現場名で昇順
                sortListNotWaterTime = this.$_sorting(listNotWaterTime, "delivery_destination_name");
                // listにset
                for (let data of sortListWaterTime) {
                    list.push(data);
                }
                for (let data of sortListNotWaterTime) {
                    list.push(data);
                }
                return list;
            },
            "setSelectDate": {
                get() {
                    return this.params.date;
                },
                set(val) {
                    this.params.date = val;
                    this.params.month = `${this.getDateValue(val).YYYY}-${this.getDateValue(val).MM}`;
                },
            },
        },
        async created() {
            this.setDate();
            this.fetchingListDrivers();
            this.fetchingListVehicles();
            const drivers = await this.sync.drivers;
            const vehicles = await this.sync.vehicles;
            this.fetchingListDailyReports(drivers, vehicles);
        },
        "methods": {
            calcLapseTime(time1, time2) {
                // 時間の差分を計算
                let lapseTime = "";
                if (time1 && time2) {
                    const date1 = new Date(`${this.params.date}T${time1}`);
                    const date2 = new Date(`${this.params.date}T${time2}`);
                    const difference = date2.getTime() - date1.getTime();
                    lapseTime = Math.floor( difference / 60000 );
                }
                return lapseTime;
            },
            setClassWarning(time1, time2) {
                // 時間差分が80以上の場合classを追加
                let classWarning = "";
                const lapseTime = this.calcLapseTime(time1, time2);
                if (Number(lapseTime) > 79) {
                    classWarning = "is-text-red";
                }
                return classWarning;
            },
            setTable() {
                // 車両が選択された場合、一覧の項目を変更する
                let table = [];
                table = JSON.parse(JSON.stringify(tableDailyReports));
                if (this.selectMode === "vehicle") {
                    table[2].class = "";
                    table[2].head = "ドライバーID";
                    table[2].key = "driver_id";
                    table[3].class = "";
                    table[3].head = "ドライバー";
                    table[3].key = "driver_name";
                }
                this.tableSet = table;
                return this.tableSet;
            },
            getDateValue(data) {
                // dateを取得
                const date = data ? new Date(data) : new Date();
                const year = date.getFullYear();
                const month = date.getMonth() + 1;
                const day = date.getDate();
                const zero = (number) => {
                    return ("0" + number).slice(-2);
                };
                return {
                    "date": date,
                    "YYYY": year,
                    "M": month,
                    "D": day,
                    "MM": zero(month),
                    "DD": zero(day),
                    "normal": `${year}${zero(month)}${zero(day)}`,
                    "jp": `${year}年${zero(month)}月${zero(day)}日`,
                    "db": `${year}-${zero(month)}-${zero(day)}`,
                    "dot": `${year}.${zero(month)}.${zero(day)}`,
                    "slash": `${year}/${zero(month)}/${zero(day)}`,
                    "financialMonth": `${year}年${zero(month)}月度`,
                };
            },
            setDate() {
                // 今日の日付をset
                this.params.date = this.getDateValue().db;
                // 今日の日付から今月をset
                this.params.month = `${this.getDateValue().YYYY}-${this.getDateValue().MM}`;
            },
            pdfDownload() {
                const table = [];
                let driverName = "";
                let selectDetail = [];
                if (this.selectMode === "driver") {
                    selectDetail = this.listDailyReportsDetail;
                } else if (this.selectMode === "vehicle") {
                    selectDetail = this.listDailyReportsDetailVehicle;
                }
                // テーブルを生成
                table[0] = [];
                // thを追加
                table[0].push("日付");
                for (let tableSetData of this.tableSet) {
                    if (tableSetData.key === "delivery_allocations_amount") {
                        table[0].push("納入量");
                    } else if (tableSetData.key.indexOf("lapse_time") === 0) {
                        table[0].push("");
                    } else {
                        table[0].push(tableSetData.head.replace(/[！-～]/g, (v) => String.fromCharCode(v.charCodeAt(0) - 0xFEE0)).replace(/”/g, "\"").replace(/’/g, "'").replace(/‘/g, "`").replace(/￥/g, "\\"));
                    }
                }
                // tdを追加（複数行対応）
                const arrayDate = [];
                for (let date in selectDetail) {
                    arrayDate.push(date);
                }
                // 日付をsort
                arrayDate.sort((a, b) => {
                    return (a > b ? 1 : -1);
                });
                for (let date of arrayDate) {
                    // 工場発時刻（元・残水時刻）でsort
                    let sortDayList = selectDetail[date].sort((a, b) => {
                        return (a.residual_water_time > b.residual_water_time ? 1 : -1);
                    });
                    for (let data of sortDayList) {
                        const tr = [];
                        tr.push(date);
                        for (let i of this.tableSet) {
                            if (i.key === "contractor" || i.key === "delivery_destination_name") {
                                tr.push(data[i.key].replace(/[！-～]/g, (v) => String.fromCharCode(v.charCodeAt(0) - 0xFEE0)).replace(/”/g, "\"").replace(/’/g, "'").replace(/‘/g, "`").replace(/￥/g, "\\"));
                            } else if (i.key === "checked_residual_water") {
                                let checked = "";
                                if (data.residual_water_time) {
                                    checked = "v";
                                }
                                tr.push({
                                    "text": checked,
                                    "alignment": "center",
                                });
                            } else if (i.key === "lapse_time_1") {
                                tr.push(this.calcLapseTime(data.residual_water_time, data.site_arrival_time));
                            } else if (i.key === "lapse_time_2") {
                                tr.push(this.calcLapseTime(data.site_arrival_time, data.site_departure_time));
                            } else if (i.key === "lapse_time_3") {
                                tr.push(this.calcLapseTime(data.site_departure_time, data.factory_arrival_time));
                            } else {
                                tr.push(data[i.key]);
                            }
                        }
                        table.push(tr);
                    }
                }
                // ドライバー名を取得
                for (let data of this.listDrivers) {
                    if (data.driver_id === this.selectDriver) {
                        driverName = data.driver_name;
                    }
                }
                // 横向きでPDFをリセット
                this.$_resetPdf({
                    "pageOrientation": "landscape", 
                });
                // PDFにタイトル・テキスト・サイン用テーブルを追加
                this.$_addPdfContent({
                    "table": {
                        "body": [
                            [
                                {
                                    "stack": [
                                        {
                                            "text": `運転日報 (${this.getDateValue(this.params.date).financialMonth})`,
                                            "style": "title",
                                        },
                                        {
                                            "text": this.selectMode === "driver" ? `ドライバー: ${driverName}` : this.selectMode === "vehicle" ? `車両ID: ${this.selectVehicle}` : "",
                                            "style": "text",
                                        },
                                    ],
                                },
                                {
                                    "table": {
                                        "body": [
                                            [
                                                {
                                                    "text": "検印欄",
                                                    "alignment": "center",
                                                    "colSpan": "4",
                                                },
                                                {},
                                                {},
                                                {},
                                            ],
                                            [
                                                {
                                                    "text": "QMR",
                                                    "alignment": "center",
                                                },
                                                {
                                                    "text": "工場長",
                                                    "alignment": "center",
                                                },
                                                {
                                                    "text": "課長",
                                                    "alignment": "center",
                                                },
                                                {
                                                    "text": "係長",
                                                    "alignment": "center",
                                                },
                                            ],
                                            [
                                                {
                                                    "image": stamp[this.stamp.qmr],
                                                    "width": 35,
                                                    "alignment": "center",
                                                    "margin": [0, 3, 0, 0],
                                                },
                                                {
                                                    "image": stamp[this.stamp.plantManager],
                                                    "width": 35,
                                                    "alignment": "center",
                                                    "margin": [0, 3, 0, 0],
                                                },
                                                {
                                                    "image": stamp[this.stamp.sectionChief1],
                                                    "width": 35,
                                                    "alignment": "center",
                                                    "margin": [0, 3, 0, 0],
                                                },
                                                {
                                                    "image": stamp[this.stamp.sectionChief2],
                                                    "width": 35,
                                                    "alignment": "center",
                                                    "margin": [0, 3, 0, 0],
                                                },
                                            ],
                                        ],
                                        "heights": [15, 15, 40],
                                        "widths": [50, 50, 50, 50],
                                    },
                                    "style": "tableStamp",
                                },
                            ],
                        ],
                        "widths": ["*", "auto"],
                    },
                    "layout": "noBorders",
                    "margin": [0, 0, 0, 20],
                });
                // PDFにデータテーブルを追加
                this.$_addPdfContent({
                    "table": {
                        "body": table,
                        "widths": [50, "*", "*", 55, 45, 45, 20, 45, 15, 45, 15, 45, 15, 45],
                    },
                    "style": "table",
                });
                // PDFを出力
                this.$_pdfDownload(`運転日報（${this.getDateValue(this.params.date).financialMonth}）`);
            },
            fetchingListDrivers() {
                // 全ドライバーデータ取得
                this.sync.drivers = common.$_axios.get(
                    `${common.$_configs.apiUrl}/drivers`,
                    this.$_requestConfig()
                ).then(response => {
                    // ドライバーIDで昇順
                    this.listDrivers = response.data.sort((a, b) => a.driver_id - b.driver_id);
                    this.selectDriver = this.listDrivers[0].driver_id;
                }).catch(() => {
                    this.$_modalError("fetchingDriversError");
                });
            },
            fetchingListVehicles() {
                // 全車両データ取得
                this.sync.vehicles = common.$_axios.get(
                    `${common.$_configs.apiUrl}/vehicles`,
                    this.$_requestConfig()
                ).then(response => {
                    // 車両IDで昇順
                    this.listVehicles = response.data.sort((a, b) => a.vehicle_id - b.vehicle_id);
                    this.selectVehicle = this.listVehicles[0].vehicle_id;
                }).catch(() => {
                    this.$_modalError("fetchingVehiclesError");
                });
            },
            fetchingListDailyReports() {
                this.$_requestCancel("SelectDate");
                if (this.params.date && this.selectDriver) {
                    // 運転日報データ取得
                    common.$_axios.get(
                        `${common.$_configs.apiUrl}/daily_reports/${this.selectDriver}`,
                        this.$_requestConfig("SelectDate")
                    ).then(response => {
                        this.listDailyReports = response.data;
                    }).catch(() => {
                        this.$_modalError("fetchingDailyReportsError");
                    });
                } else {
                    this.$_modalError("fetchingDailyReportsError");
                }
            },
            fetchingListDailyReportsVehicle() {
                this.$_requestCancel("SelectDate");
                if (this.params.date && this.selectVehicle) {
                    // 運転日報データ取得（車両別）
                    common.$_axios.get(
                        `${common.$_configs.apiUrl}/daily_reports_vehicle/${this.selectVehicle}`,
                        this.$_requestConfig("SelectDate")
                    ).then(response => {
                        this.listDailyReportsVehicle = response.data;
                    }).catch(() => {
                        this.$_modalError("fetchingDailyReportsVehicleError");
                    });
                } else {
                    this.$_modalError("fetchingDailyReportsVehicleError");
                }
            },
            fetchingListDailyReportsDetail() {
                if (this.params.month && this.selectDriver) {
                    // 運転日報詳細データ取得
                    common.$_axios.get(
                        `${common.$_configs.apiUrl}/daily_reports_detail/${this.selectDriver}`,
                        this.$_requestConfig("params")
                    ).then(response => {
                        this.listDailyReportsDetail = response.data;
                        this.pdfDownload();
                    }).catch(() => {
                        this.$_modalError("fetchingDailyReportsDetailError");
                    });
                } else {
                    this.$_modalError("fetchingDailyReportsDetailError");
                }
            },
            fetchingListDailyReportsDetailVehicle() {
                if (this.params.month && this.selectVehicle) {
                    // 運転日報詳細データ取得（車両別）
                    common.$_axios.get(
                        `${common.$_configs.apiUrl}/daily_reports_detail_vehicle/${this.selectVehicle}`,
                        this.$_requestConfig("params")
                    ).then(response => {
                        this.listDailyReportsDetailVehicle = response.data;
                        this.pdfDownload();
                    }).catch(() => {
                        this.$_modalError("fetchingDailyReportsDetailVehicleError");
                    });
                } else {
                    this.$_modalError("fetchingDailyReportsDetailVehicleError");
                }
            },
            download() {
                // PDFダウンロード
                if (this.selectMode === "driver") {
                    this.fetchingListDailyReportsDetail();
                } else if (this.selectMode === "vehicle") {
                    this.fetchingListDailyReportsDetailVehicle();
                }
            },
            changeDate() {
                // 日付を変更
                if (this.selectMode === "driver") {
                    this.fetchingListDailyReports();
                } else if (this.selectMode === "vehicle") {
                    this.fetchingListDailyReportsVehicle();
                }
            },
        },
    };
</script>

<style lang="scss" scoped>
    .is-wrap {
        min-width: 160px;
    }
</style>
